// src/socket.js
import { io } from "socket.io-client";
import { API_URL } from "./api/apiConfig";

// ✅ Conecta una sola vez al backend (misma base que axios /auth/token)
export const socket = io(API_URL, {
  withCredentials: true,
});

// Logs útiles para debug
socket.on("connect", () => {
  console.log("🟢 Conectado a Socket.IO:", socket.id);
});

socket.on("disconnect", () => {
  console.log("🔴 Desconectado de Socket.IO");
});
